import {AuditService} from "../PA.Core/Security/AuditService";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {SnapshotTypeBO} from "./SnapshotTypeBO";
import { esWB_Subject_Area} from "../PA.Core/PAdbSchema";

export class SnapshotTypeBOAudit {


    static async SnapshotTypeAuditBO(SnapshotTypeBO: SnapshotTypeBO): Promise<AuditService> {
        const self = SnapshotTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("SnapshotType", self.drWB_SnapshotType.cif.WB_SNAPSHOTM_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const snapshotTypeParams: IAuditField [] = [
            {fieldName: "SNAPSHOT_TYPE_ID",              realName: "ID"}, //create
            {fieldName: "SNAPSHOT_TYPE_NAME",                realName: "Name", bAllMsg: true}, //create
            {fieldName: "PARENT_PERIOD_SHOW_IND",  realName: "Parent Period Show Ind",},
            {fieldName: "WB_PERIODM_ID_PARENT",        realName: "Parent Period ID"},
            {fieldName: "PERIOD_SHOW_IND",          realName: "Period Show Ind"},
            {fieldName: "WB_PERIODM_ID",         realName: "Period ID"},
            {fieldName: "PREV_SNAPSHOT_SHOW_IND",       realName: "Previous Snapshot Show"},
            {fieldName: "EVENT_SPEND_ACCRUAL_SHOW_IND",         realName: "Event Spend Accrual Show"},
            {fieldName: "GLRULE_SUBSET_IDS",              realName: "GL Rule Subset ID" }, //create
            {fieldName: "DAY_OFFSET_SHOW_IND",                realName: "Day Offset Show Ind" }, //create
            {fieldName: "OFFSET_BASIS_ID",  realName: "Offset Basis ID",},
            {fieldName: "JOB_OPTIONS_SHOW_IND",        realName: "Job Options"},
            {fieldName: "JOB_OPTIONS_DEFAULT",          realName: "Job Options Default"},
            {fieldName: "WORKFLOW_SHOW_IND",         realName: "Workflow Show"},
            {fieldName: "WB_WORKFLOW_ID",       realName: "Workflow ID"},
            {fieldName: "PROD_LEVEL_SHOW_IND",         realName: "Product Level Show"},
            {fieldName: "CUST_LEVEL_SHOW_IND",              realName: "Customer Level Show" }, //create
            {fieldName: "EDIT_ROLES",                realName: "Edit Roles" }, //create
            {fieldName: "VIEW_ROLES",  realName: "View Roles",},
            {fieldName: "AUTO_RUN_IND",        realName: "Auto Run"},
            {fieldName: "SERVER_PROCESS_ID",          realName: "Server Process ID"},
            {fieldName: "PAYMENTMETHOD_OPTIONS",         realName: "Payment Method Options"},
            {fieldName: "AUTO_RUN_IND",       realName: "Parent Snapshot Show"},
            {fieldName: "RECURRING_SHOW_IND",         realName: "Recurring Show"},
            {fieldName: "CUSTOMER_LIST_SHOW_IND",              realName: "Customer List Show"}, //create
            {fieldName: "PRODUCTGROUP_LIST_SHOW_IND",                realName: "Product Group List Show"}, //create
            {fieldName: "PERIOD_LIST_SHOW_IND",  realName: "Period List Show",},
            {fieldName: "PLAN_LIST_SHOW_IND",        realName: "Plan List Show"},
            {fieldName: "ENTERPRISE_POLICY",        realName: "Snapshot Enterprise Structure Policy"},



        ]

        // TPM SubjectArea Rows
        const subjectAreaParams: IAuditField [] = [
          {fieldName: "WB_SUBJECTAREA_ID",
                fkMapper: esWB_Subject_Area,
                fkMapperNameField: "SUBJECT_AREA_NAME",
                fkMapperIdField: "SUBJECT_AREA_ID",
                bAllMsg: true,
                realName: "SubjectArea", },
           ]





        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_SnapshotType, snapshotTypeParams, {objectName: 'SnapshotType', deletedKeys: deleteKeys})

        // Snapshot Type Subject Area Rows
        for(let aTPMEventRow of self.drWB_SnapshotType.WB_SnapshotTypeSubjectAreaRows) {
            await AuditUtils.logRecord(auditService, aTPMEventRow, subjectAreaParams,{objectName: 'SnapshotType Subject Area', deletedKeys: deleteKeys})
        }






        return auditService
    }



}
